import React from 'react';

const SpendingHabitsIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <rect x="3" y="7" width="26" height="19" rx="4" fill="#64B5F6"/>
        <rect x="3" y="7" width="26" height="19" rx="4" fill="url(#cardShine)"/>
        <rect x="6" y="12" width="6" height="4.5" rx="1" fill="#FFE699"/>
        <rect x="6" y="12" width="6" height="4.5" rx="1" fill="none" stroke="#F0C24B" strokeWidth="0.5"/>
        <path d="M6 14.25h6M8 12v4.5" stroke="#F0C24B" strokeWidth="0.4" opacity="0.7"/>
        <circle cx="22" cy="20.5" r="4" fill="#EF5350" opacity="0.85"/>
        <circle cx="25.5" cy="20.5" r="4" fill="#FFB74D" opacity="0.85"/>
        <path d="M6 20h6" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" opacity="0.9"/>
        <defs>
            <linearGradient id="cardShine" x1="3" y1="7" x2="29" y2="26" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#fff" stopOpacity="0.25"/>
                <stop offset="0.5" stopColor="#fff" stopOpacity="0"/>
                <stop offset="1" stopColor="#000" stopOpacity="0.06"/>
            </linearGradient>
        </defs>
    </svg>
);

export default SpendingHabitsIcon;